import { IconClose } from '@ui/src';

import { SelectedPrimaryAccountTypes } from './types';

import cn from './auto-settings.module.css';

const SelectedPrimaryAccount = ({
  selectedPrimaryAccount,
  selectedPrimaryAccounts,
  setSelectedPrimaryAccounts,
  accountCategories,
  primaryAccountsList,
  setSelectedPrimaryAccountsCollapsed,
  onChange,
}: SelectedPrimaryAccountTypes) => {
  const currentPrimaryAccount = primaryAccountsList?.find(
    (primary) => primary.id === selectedPrimaryAccount,
  );
  const currentCategory = accountCategories?.find((category) =>
    category?.accountGroups?.find(
      (group) => group.id === currentPrimaryAccount?.groupId,
    ),
  );
  const currentGroup = currentCategory?.accountGroups?.find(
    (group) => group.id === currentPrimaryAccount?.groupId,
  );

  return (
    <div className={cn.selectedPrimaryAccount}>
      <div className={cn.selectedPrimaryAccountLeft}>
        <div
          className={cn.selectedPrimaryAccountNumber}
        >{`${currentCategory?.number}.${currentGroup?.number}.${currentPrimaryAccount?.number}`}</div>
        {currentPrimaryAccount?.description}
      </div>
      <button
        type="button"
        className={cn.deleteSelectedPrimaryAccount}
        onClick={() => {
          const nextSelectedPrimaryAccounts = selectedPrimaryAccounts?.filter(
            (selectedPrimary) => selectedPrimary !== selectedPrimaryAccount,
          );

          setSelectedPrimaryAccounts(nextSelectedPrimaryAccounts as string[]);

          if (
            nextSelectedPrimaryAccounts &&
            nextSelectedPrimaryAccounts?.length <= 5
          ) {
            setSelectedPrimaryAccountsCollapsed(true);
          }

          if (onChange) {
            onChange(nextSelectedPrimaryAccounts);
          }
        }}
      >
        <IconClose width={12} height={12} />
      </button>
    </div>
  );
};

export default SelectedPrimaryAccount;
